import React, { useEffect } from 'react';
import { logout } from '@/services/auth';

interface LogoutPageProps {}

const LogoutPage: React.FC<LogoutPageProps> = () => {
    useEffect(() => {
        async function doLogout() {
            try {
                await logout();
            } finally {
                // Full reload (not a client-side redirect) so cached state — including MainRouting's
                // one-time getCurrentUser() — is discarded and auth is re-evaluated. A client-side
                // redirect would land on the logged-in Home route because that state is still stale.
                window.location.replace('/');
            }
        }

        doLogout();
    }, []);

    return null;
};

export default LogoutPage;
